// extracted by mini-css-extract-plugin
export default {"Down":"DataDownload_Down__vNlDb","all":"DataDownload_all__wLCli"};